import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";

class RemoveShippingAddressForm extends Component {

  render() {
    let {handleSubmit, submitting, label} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Are you sure you want to remove the shipping address <strong>{label}</strong>?</p>
        </div>
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RemoveShippingAddressForm"
})(RemoveShippingAddressForm);

export default ReduxForm;